/**
 * Хаяг ↔ координат — OpenStreetMap Nominatim.
 *
 * ХОЁР ЧИГЛЭЛ
 *  · `searchAddress` — бичсэн хаягаар байршил олно
 *  · `addressAt`     — зураг дээрх цэгээс хаяг гаргана
 *
 * ⚠️ ГУРАВДАГЧ ДОМЭЙН (`nominatim.openstreetmap.org`). Газрын зурагтай
 *    ижил шийдвэр: УБ-ын админ панель, интернэттэй ажиллана. Оросын
 *    офлайн апп (`apps/mobile`) энэ файлыг ХЭЗЭЭ Ч импортлохгүй.
 *
 * ⚠️ Nominatim-ийн ашиглалтын журам: секундэд ≤1 хүсэлт, автомат
 *    урсгал хориотой. Тиймээс эдгээр функц нь ЗӨВХӨН товч дарахад
 *    дуудагдана — бичих бүрд биш. Автоматаар дуудаж эхэлбэл хаяг
 *    бөглөх бүрд 20-30 хүсэлт явж, IP хаагдана.
 *
 * ⚠️ Алдааг ШИДЭХГҮЙ, `null` буцаана. Хаяг олдохгүй байх нь энгийн
 *    зүйл (шинэ хороолол, буруу бичилт) — маягт унтрах ёсгүй.
 */

const BASE = 'https://nominatim.openstreetmap.org';

/** Монголоор хариу авах ба Монгол улсаар хязгаарлах. */
const COMMON = 'format=jsonv2&accept-language=mn&countrycodes=mn';

/** Сүлжээ удаан бол маягт өлгөгдөхгүй — 8 секунд хүрэлцээтэй. */
const TIMEOUT_MS = 8_000;

export interface GeoHit {
  lat: number;
  lng: number;
  /** Nominatim-ийн бүтэн нэр — «Сүхбаатар дүүрэг, Улаанбаатар, …» */
  address: string;
}

async function get(url: string): Promise<unknown | null> {
  try {
    const res = await fetch(url, {
      headers: { Accept: 'application/json' },
      signal: AbortSignal.timeout(TIMEOUT_MS),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    // Сүлжээгүй, timeout, CORS — бүгд «олдсонгүй»-тэй ижил үр дүн
    return null;
  }
}

/** Бичсэн хаягаар байршил хайна. Хамгийн тохирох 5-ыг буцаана. */
export async function searchAddress(query: string): Promise<GeoHit[]> {
  const q = query.trim();
  if (q.length < 3) return [];

  const data = await get(`${BASE}/search?${COMMON}&limit=5&q=${encodeURIComponent(q)}`);
  if (!Array.isArray(data)) return [];

  return data.flatMap((row: unknown) => {
    const r = row as { lat?: string; lon?: string; display_name?: string };
    const lat = Number(r.lat);
    const lng = Number(r.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return [];
    return [{ lat, lng, address: r.display_name ?? '' }];
  });
}

/** Зураг дээрх цэгээс хаяг гаргана. Олдохгүй бол `null`. */
export async function addressAt(lat: number, lng: number): Promise<string | null> {
  const data = await get(`${BASE}/reverse?${COMMON}&lat=${lat}&lon=${lng}`);
  const r = data as { display_name?: string } | null;
  return r?.display_name ?? null;
}
